import React from 'react';
import { Disclosure as HeadlessDisclosure } from '@headlessui/react';
import classNames from 'classnames';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import RichText from '../rich-text';

const Disclosure: React.FC<{
	title: string;
	className: string;
	children: JSX.Element;
}> = ({ title, className, children }) => {
	return (
		<div>
			<HeadlessDisclosure>
				{({ open }) => (
					<div className='md:w-[576px]'>
						<HeadlessDisclosure.Button
							className={classNames(
								className ||
									'flex w-full justify-between rounded-lg items-center pl-5 pr-3 py-2.5 text-base text-left text-font border border-2 hover:border-brand hover:ring-brand',
								{
									'border-neutral ring-brand': !open,
									'border-brand ring-brand': open,
								}
							)}>
							<RichText html={title} />
							<ChevronDownIcon
								className={classNames('h-8 w-8 text-font', {
									'rotate-180 transform': open,
								})}
							/>
						</HeadlessDisclosure.Button>
						<HeadlessDisclosure.Panel className="text-font text-sm px-5 pb-8">
							{children}
						</HeadlessDisclosure.Panel>
					</div>
				)}
			</HeadlessDisclosure>
		</div>
	);
};

export default Disclosure;
